export default "/video-empty-state.64945e38-a0cd3b.png";